// src/components/HistoryPage.jsx
import React, { useState } from "react";
import { TabGroup, TabPanels, TabPanel } from "@headlessui/react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

// Neue Komponente mit dem aktuellen Rundenverlauf
import CurrentRoundHistory from "../components/history/components/CurrentRoundHistory";
// Deine bereits existierende <History />-Komponente
import History from "../components/history/History";
// Import HistoryTabNavigation
import HistoryTabNavigation from "../components/history/components/HistoryTabNavigation";

const HistoryPage = () => {
  const { t } = useTranslation();
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleTabChange = (index) => {
    setSelectedIndex(index);
    setIsMobileDropdownOpen(false);
  };

  return (
    <div className="min-h-screen py-8 bg-background">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <TabGroup selectedIndex={selectedIndex} onChange={setSelectedIndex}>
          <HistoryTabNavigation
            selectedIndex={selectedIndex}
            isMobileDropdownOpen={isMobileDropdownOpen}
            setIsMobileDropdownOpen={setIsMobileDropdownOpen}
            onTabChange={handleTabChange}
          />

          <TabPanels className="mt-4">
            <TabPanel>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4 }}
                className="max-w-4xl mx-auto"
              >
                <History />
              </motion.div>
            </TabPanel>
            <TabPanel>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4 }}
                className="max-w-4xl mx-auto"
              >
                <CurrentRoundHistory />
              </motion.div>
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </div>
    </div>
  );
};

export default HistoryPage;
